import { AnyAction } from 'redux'

export interface IMemberState {
  token?: string
  refresh_token: string
  expires: number
  name: string
  image: string
}

export const initialMember: IMemberState = {
  token: '',
  refresh_token: '',
  expires: 0,
  name: '',
  image: '',
}

export const SET_MEMBER_TOKEN = 'SET_MEMBER_TOKEN'
export const SET_LOGIN_TOKENS = 'SET_LOGIN_TOKENS'
export const SET_INFO = 'SET_INFO'

export function setToken(token: string) {
  return {
    type: SET_MEMBER_TOKEN,
    token,
  }
}

export function setInfo(name: string, image: string) {
  return {
    type: SET_INFO,
    name,
    image,
  }
}

export function setLoginTokens(
  token: string,
  refreshToken: string,
  expires: number,
) {
  const expiresDateTime =
    Number(new Date(Date.now()).getTime()) + expires * 1000
  return {
    type: SET_LOGIN_TOKENS,
    token,
    refreshToken,
    expires: expiresDateTime,
  }
}

export function memberReducer(
  state = initialMember,
  action: AnyAction,
): IMemberState {
  switch (action.type) {
    case SET_MEMBER_TOKEN:
      return { ...state, token: action.token }
    case SET_INFO:
      return { ...state, name: action.name, image: action.image }
    case SET_LOGIN_TOKENS:
      return {
        ...state,
        token: action.token,
        refresh_token: action.refreshToken,
        expires: action.expires,
      }
    default:
      return state
  }
}
